function injectStyle (ssrContext) {
  require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":0,\"remove\":true}!css-loader!../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-2394f41b\",\"scoped\":false,\"hasInlineConfig\":false}!less-loader?{\"globalVars\":{\"museUiTheme\":\"'/usr/src/app/node_modules/muse-ui/src/styles/themes/variables/default.less'\"}}!../../../vue-loader/lib/selector?type=styles&index=0!./pageItem.vue")
}
var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./pageItem.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2394f41b\",\"hasScoped\":false}!../../../vue-loader/lib/selector?type=template&index=0!./pageItem.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/muse-ui/src/pagination/pageItem.vue
// module id = 3380
// module chunks = 1